import { useEffect, useRef, useState } from "react";

// Hover-to-peek for a collapsed panel: open shortly after the pointer arrives, close shortly after it leaves.
// Only on devices with a real hover pointer (mouse / trackpad); touch screens keep tap-to-open.
const canHover = () => {
  try { return window.matchMedia("(hover: hover) and (pointer: fine)").matches; } catch { return false; }
};

export default function useHoverPeek(enabled, { openDelay = 120, closeDelay = 280 } = {}) {
  const [peek, setPeek] = useState(false);
  const timer = useRef(null);
  const clear = () => { if (timer.current) { clearTimeout(timer.current); timer.current = null; } };

  useEffect(() => clear, []);
  useEffect(() => { if (!enabled) { clear(); setPeek(false); } }, [enabled]);

  const onMouseEnter = () => {
    if (!enabled || !canHover()) return;
    clear();
    timer.current = setTimeout(() => setPeek(true), openDelay);
  };
  const onMouseLeave = () => {
    clear();
    timer.current = setTimeout(() => setPeek(false), closeDelay);
  };
  const close = () => { clear(); setPeek(false); };

  return { peek: enabled && peek, close, bind: { onMouseEnter, onMouseLeave } };
}
